import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthenticationService, ToastService } from 'src/app/services';
import { IApiResponse } from 'src/app/interfaces';

@Injectable()
export class MessagesInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (!(event instanceof HttpResponse)) {
            return;
          }
          if ((event.body as any).messages === undefined) {
            return;
          }
          for (let message of (event.body as IApiResponse).messages) {
            this.toastService.success(message);
          }
        },
        error: ({ error, status }: HttpErrorResponse) => {
          if (status === 401) {
            this.authenticationService.logoutUsuario();
            return;
          }

          if (!(error as IApiResponse).messages) {
            return;
          }

          for (let message of (error as IApiResponse).messages) {
            this.toastService.error(message);
          }
        }
      })
    );
  }
}
